const NtunaCTA = () => {
    return (
      <div className="width-800 margin-auto ntuna-cta-container">
        <ul className="page-sections-container">
          <li className="page-section-item center">
            <h2 className="page-section-title ntuna-text-fill">
              Let’s Do Something Great For You
            </h2>
            <p>
              Discuss your web, digital, and ICT needs with our team of experts.
              Whatsapp or give us a call on{" "}
              <a href="tel:+256702096666">+256-702-096-666</a>,{" "}
              <a href="tel:+13153470333">+1-315-347-0333</a> and{" "}
              <a href="tel:+256771001999">+256-771-001-999</a> or send us an
              email to <a href="mailto:info@ntuna.com">info@ntuna.com.</a>
            </p>
            <div className="width-300 margin-auto">
              {" "}
              <a
                href="https://form.jotform.com/ntuna/get-free-quote"
                target="_blank"
                rel="noopener noreferrer"
                className="maincta button boldTitle"
              >
                <span>Request Free Quote</span>
              </a>
            </div>
          </li>
        </ul>
      </div>
    );
}
 
export default NtunaCTA;